export const normalizeLocaleCode = (input: string | null | undefined): string => {
  if (!input) return 'en';
  const normalized = input.trim().toLowerCase().replace(/\s+/g, '').replace(/_/g, '-');
  return normalized || 'en';
};

export const baseLocaleCode = (code: string): string => {
  const normalized = normalizeLocaleCode(code);
  const index = normalized.indexOf('-');
  return index === -1 ? normalized : normalized.slice(0, index);
};

export const pickBestLocale = (
  preferred: string,
  available: string[],
  fallback = 'en',
): string => {
  const normalizedAvailable = available.map((item) => normalizeLocaleCode(item));
  if (!normalizedAvailable.length) {
    return normalizeLocaleCode(fallback);
  }

  const normalizedPreferred = normalizeLocaleCode(preferred);
  const normalizedFallback = normalizeLocaleCode(fallback);

  const exactMatch = normalizedAvailable.find((code) => code === normalizedPreferred);
  if (exactMatch) return exactMatch;

  const preferredBase = baseLocaleCode(normalizedPreferred);
  const baseMatch = normalizedAvailable.find((code) => baseLocaleCode(code) === preferredBase);
  if (baseMatch) return baseMatch;

  if (normalizedAvailable.includes(normalizedFallback)) {
    return normalizedFallback;
  }

  return normalizedAvailable[0] ?? normalizedFallback;
};
